import { colors, Grid, TextField } from '@material-ui/core';
import { ContactStyle } from './style';
import CustomInput from 'components/CustomInput';
import { isValidPhoneNumber } from 'react-phone-number-input';
import Input from 'react-phone-number-input/input';
import { forwardRef, useEffect, useState } from 'react';

const phoneInput = forwardRef((props, ref) => {
    return (
        <TextField
            fullWidth 
            {...props}
            inputRef={ref}
            variant='outlined'
            name='phone'
        />
    )
})

const Contact = ({ contact, onValueChange, showMandatoryError, errors, name = '', title = '', readOnly = false }) => {
    const classes = ContactStyle();
   
    return (
        <Grid className={classes.wrapper} container spacing={2}>
            <Grid item xs>
                <CustomInput
                    fullWidth
                    id="pocName"
                    label={"Name"}
                    value={contact?.[`${name}PocName`]}
                    elementType="input"
                    onChange={val => onValueChange("PocName", val)}
                    required
                    readOnly = {readOnly}
                />
            </Grid>
            <Grid item xs>
                <CustomInput
                    id="pocEmail"
                    label={"Email"}
                    value={contact?.[`${name}PocEmail`]}
                    elementType="input"
                    onChange={val => onValueChange("PocEmail", val)}
                    valid={(!errors[`${name}PocEmail`]) && !(showMandatoryError && !contact?.[`${name}PocEmail`])}
                    required
                    readOnly = {readOnly}
                />
            </Grid>
            {[1, 2, 3].map((num) => {
                const key = num === 1 ? "PocPhone" : `PocPhone${num}`;
                const value = contact?.[`${name}${key}`];
                const label = `Phone${num > 1 ? ` ${num}` : ""}`;

                const error =
                    (value && !isValidPhoneNumber(value)) ||
                    (showMandatoryError && num === 1 && !value);

                return (
                    <Grid item xs key={key}>
                        <Input
                            variant="outlined"
                            defaultCountry="US"
                            value={value || ''}
                            onChange={val => onValueChange(key, val)}
                            error={error}
                            label={label}
                            required={num === 1}
                            fullWidth
                            InputLabelProps={{ className: classes.label }}
                            inputComponent={phoneInput}
                            readOnly={readOnly}
                            className={classes.phoneInput}
                        />
                    </Grid>
                );
                })}
        </Grid>
    );
}
export default Contact;



